import {
  FieldHtmlNameUtil, HekateDisplayForm,
} from 'www-shared';
import { Ref } from 'vue';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import AbstractSignupScreen from './AbstractSignupScreen';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import ErrorUtil from '../../../../../util/ErrorUtil';
import UnifiedSignupSessionInfo from '../session-info/UnifiedSignupSessionInfo';
import UnifiedSignupPlan from '../session-info/UnifiedSignupPlan';
import UnifiedSignupIntent from '../session-info/UnifiedSignupIntent';

export default class ChoosePlanSignupScreen extends AbstractSignupScreen {
  public readonly screenName: UnifiedSignupScreenName;

  public readonly onUpdatePage: VoidFunction;

  constructor({
    sessionInfo,
    formDefinition,
    screenName,
    onUpdatePage,
    isBackButtonHidden,
  }: {
    sessionInfo: Ref<UnifiedSignupSessionInfo>;
    formDefinition: Ref<HekateDisplayForm>;
    screenName: UnifiedSignupScreenName,
    onUpdatePage: VoidFunction,
    isBackButtonHidden: Ref<boolean>
  }) {
    super({ sessionInfo, formDefinition, isBackButtonHidden });
    this.screenName = screenName;
    this.onUpdatePage = onUpdatePage;
  }

  // eslint-disable-next-line class-methods-use-this
  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.chooseYourOnshapePlan),
      }),
    ];
  }

  // eslint-disable-next-line class-methods-use-this
  public predicate(): boolean {
    throw ErrorUtil.internalError({ msg: 'ChoosePlanSignupScreen has no predicate' });
  }

  public async initListeners({
    partialDiv,
  }: {
    partialDiv: HTMLDivElement,
  }): Promise<void> {
    this.listenForFormInputs({
      partialDiv,
      fieldName: FieldHtmlNameUtil.chooseYourOnshapePlan,
    });
    /** listen for show all plans */
    const showAllPlans = partialDiv.querySelector('.show-all-plans-link');
    showAllPlans?.addEventListener('click', (e) => {
      e.preventDefault();
      const choosePlanField = this.getField(FieldHtmlNameUtil.chooseYourOnshapePlan);
      choosePlanField.val = '';
      choosePlanField.isRequired = false;
      choosePlanField.isValidated = true;
      this.sessionInfo.value.isChooseOwnPlan = true;
      this.onUpdatePage();
    });

    /** show/hide features of plan card on mobile */
    const allCards = partialDiv.querySelectorAll('.plan-card');
    allCards.forEach((card) => {
      const featuresList = card.querySelector('.features-list');
      const showFeature = card.querySelector('.toggle-features-plan-card');
      const showSpan = card.querySelector('.show-features');
      const hideSpan = card.querySelector('.hide-features');
      if (!(featuresList instanceof HTMLDivElement) || !showFeature || !showSpan || !hideSpan) {
        return;
      }
      showFeature.addEventListener('click', (e) => {
        e.preventDefault();
        if (featuresList.classList.contains('open')) {
          featuresList.style.maxHeight = '0px';
          featuresList.classList.remove('open');
        } else {
          featuresList.style.maxHeight = `${featuresList.scrollHeight}px`;
          featuresList.classList.add('open');
        }
        showSpan.classList.toggle('hidden');
        hideSpan.classList.toggle('hidden');
      });
    });
  }

  // eslint-disable-next-line class-methods-use-this
  public async toNextScreen(): Promise<boolean> {
    const planValue = this.getField(FieldHtmlNameUtil.chooseYourOnshapePlan).val;
    if (!planValue) {
      return true;
    }
    const { persona } = this.sessionInfo.value;
    this.sessionInfo.value.isChooseOwnPlan = false;
    const plan = UnifiedSignupPlan.fromString(planValue);
    this.sessionInfo.value.chosenPlan = plan;
    if (!persona || persona.isEduPersona() || !(plan.compareTo(UnifiedSignupPlan.edu) || plan.compareTo(UnifiedSignupPlan.educator))) {
      return true;
    }

    this.sessionInfo.value.intent = UnifiedSignupIntent.eduIntent;
    this.getField(FieldHtmlNameUtil.whatIsYourExperience).val = '';
    this.sessionInfo.value.persona = null;
    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  public getProgress(): number {
    return 60; // TODO we could make this different for each instance by passing in value to the constructor
  }
}
